module.exports = __webpack_public_path__ + "img/exit-icon.e77ad8bf.svg";